import { InputEvents, Metrics, ObjectState, Surface, Obj } from "../types";
import { CreateObjectArgs, createSprite } from "../core";

type CreateRippleArgs = CreateObjectArgs & {
  w?: number;
  h?: number;
}

export const createRipple = (args: CreateRippleArgs) => {
  const sprite = createSprite({ w: args.w, h: args.h, fill: 0 });
  let A_ = 100;
  let λ_ = 20;
  let f_ = 1.5;
  let α_ = 0.005;

  const ripple = {
    ...args,
    sprite,
    setA: (v: number) => {
      A_ = v;
    },
    getA: () => A_,
    setLambda: (v: number) => {
      λ_ = v;
    },
    getLambda: () => λ_,
    setF: (v: number) => {
      f_ = v;
    },
    getF: () => f_,
    setAlpha: (v: number) => {
      α_ = v;
    },
    getAlpha: () => α_,
    step: (startTime: number, timestamp: number, inputEvents: InputEvents, metrics: Metrics, inFocus: boolean, objectState: ObjectState, surface: Surface, obj: Obj) => {
      // Reset sprite (e.g. dimensions may have changed)
      obj.sprite = createSprite({ w: obj.w, h: obj.h, fill: 0 });

      const m = Math.max(surface.rows, surface.cols) / 256;
      const A = A_ / m; // base amplitude (pixel displacement)
      const λ = λ_ / m; // wavelength (pixels)
      const f = f_ / m; // temporal frequency (cycles/sec)
      const α = α_ / m; // decay rate (1/pixel)

      // Center of the ripple (in local region coords)
      const cx = Math.floor(obj.w / 2);
      const cy = Math.floor(obj.h / 2);

      const t = (timestamp - startTime) / 1000; // time in seconds

      // Fill pixel-by-pixel
      for (let y = 0; y < obj.h; y++) {
        for (let x = 0; x < obj.w; x++) {
          const dx = x - cx;
          const dy = y - cy;
          const r = Math.hypot(dx, dy);

          // radial sinusoid with decay
          const phase = 2 * Math.PI * (r / λ - f * t);
          const u = (A / (1 + α * r)) * Math.sin(phase);

          // map u ∈ [−A, +A] to grayscale [0…255]
          // const shade = Math.round(128 + (u / A) * 127);
          const shade = u >= 0 ? 1 : 0;
          const idx = y * obj.w + x;
          obj.sprite.c[idx] = shade;
        }
      }
    }
  }

  return ripple;
}
